import React from 'react';
import ConnectedElements from './connected-elements';
import { disposeOnUnmount } from 'mobx-react';
import { reaction } from 'mobx';
import Connected from '../../../connected';
import { transformOfRotateAndFlip } from '../../../common';

export default class ConnectElementsMobile extends ConnectedElements {
    public componentDidMount() {
        disposeOnUnmount(
            this,
            reaction(
                // 连接态以及slide的切换均需重刷吸附点
                () => [this.getEditingStateManager().isConnecting,
                    this.getSelectionService()?.currentSlide,
                    this.getEditingStateManager().readyToConnect,
                    this.getEditingStateManager().isResizing,
                    this.getEditingStateManager().isDraggingElement,
                    this.getEditingStateManager().isRotating,
                ],
                () => {
                    this.elements = this.canBeConnectedElements() || [];
                    this.setState({});
                },
            ),
        );
    }

    public renderCanBeConnectedElement = (element) => {
        const elementModel = element;
        const frameOnSlide = elementModel.getFrame?.().frameOnSlide();

        return (
            <div
                key={element.id}
                style={{
                    ...frameOnSlide,
                    left: frameOnSlide.left * this.props.scale,
                    top: frameOnSlide.top * this.props.scale,
                    height: frameOnSlide.height * this.props.scale,
                    width: frameOnSlide.width * this.props.scale,
                    position: 'absolute',
                    pointerEvents: 'none',
                    transform: transformOfRotateAndFlip(frameOnSlide),
                    zIndex: 1,
                }}
            >
                <Connected
                    styleModel={elementModel.props.style}
                    component={elementModel}
                    scale={this.props.scale}
                    pathParser={elementModel.pathParser}
                    needAdsorbTip={true}
                    editingStateManager={this.getEditingStateManager()}
                >
                </Connected>
            </div>
        );
    };

    public render() {
        if (this.getEditingStateManager().readyToConnect && this.elements?.length) {
            return (
                <React.Fragment>
                    {this.elements.map(this.renderCanBeConnectedElement)}
                </React.Fragment>);
        }
        return null;
    }
}
